export default __webpack_public_path__ + "static/media/large-circle-o-plus.5f44afbc.svg";